module.exports = __webpack_public_path__ + "img/service-head-bg-5.f77546e2.jpg";